import { render, staticRenderFns } from "./NormalSearchNav226.vue?vue&type=template&id=70886882&scoped=true"
import script from "./NormalSearchNav226.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav226.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70886882",
  null
  
)

export default component.exports